import React from 'react';
import PropTypes from 'prop-types';
import { FormSection } from 'redux-form';

import PaymentSourceSelector from '../../containers/commit-form/payment-source-selector.container';

class PaymentMethod extends React.PureComponent {
  static propTypes = {
    user: PropTypes.object,
    onCardTokenized: PropTypes.func.isRequired,
    onCardError: PropTypes.func.isRequired,
    formName: PropTypes.string,
  };

  static defaultProps = {
    user: null,
    formName: null,
  };

  render() {
    const { onCardTokenized, onCardError, formName } = this.props;
    return (
      <FormSection name="card">
        <PaymentSourceSelector
          cardTokenized={onCardTokenized}
          cardError={onCardError}
          formName={formName}
        />
      </FormSection>
    );
  }
}

export default PaymentMethod;



// WEBPACK FOOTER //
// ./src/desktop/pages/single-payer-payment/payment-method.js